"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildOipDetails;

var _decodeDescriptor = _interopRequireDefault(require("./decodeDescriptor"));

var _index = require("../index");

var _buildTxids = _interopRequireDefault(require("./buildTxids"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ANY = _index.ProtoModules.google.protobuf.Any;
var OipDetails = _index.ProtoModules.oipProto.OipDetails;
var googleApis = 'type.googleapis.com/';

function serializeNameToTypeUrl(name) {
  if (name.startsWith('tmpl') && name.length === 13) {
    return "".concat(googleApis, "oipProto.templates.").concat(name);
  } else {
    return "".concat(googleApis).concat(name);
  }
}

var protoNumberFields = ['double', 'float', 'int32', 'int64', 'uint32', 'uint64', 'sint32', 'sint64', 'fixed32', 'fixed64', 'sfixed32', 'sfixed64'];

function typeConvBool(values) {
  if (Array.isArray(values)) {
    var newArray = [];

    var _iterator = _createForOfIteratorHelper(values),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        newArray.push(_typeConvBool(value));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return newArray;
  } else {
    return _typeConvBool(values);
  }
}

function _typeConvBool(value) {
  switch ((value + '').toLowerCase()) {
    case 'true':
    case 't':
    case '1':
      return true;

    case 'false':
    case 'f':
    case '0':
    case '':
      return false;

    default:
      throw new Error("Expecting a boolean. Was given: ".concat(value));
  }
}

function typeConvNumber(values) {
  if (Array.isArray(values)) {
    var newArray = [];

    var _iterator2 = _createForOfIteratorHelper(values),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var field = _step2.value;

        if (isNaN(Number(field))) {
          throw new Error("Expecting a number. Received: ".concat(field));
        } else {
          newArray.push(Number(field));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return newArray;
  } else {
    if (isNaN(Number(values))) {
      throw new Error("Expecting a number. Received: ".concat(values));
    } else {
      return Number(values);
    }
  }
}

function typeConvBytes(values) {
  if (Array.isArray(values)) {
    var newArray = [];

    var _iterator3 = _createForOfIteratorHelper(values),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var field = _step3.value;
        newArray.push(Buffer.from(field));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return newArray;
  } else {
    return Buffer.from(values);
  }
}
/**
 * Create OipDetails Proto message
 * @param {Array.isArray<Object>|Object} data
 * @param data.name - template name
 * @param data.payload - template object information (fields with assigned values)
 * @param [data.descriptor] - the file descriptor that defines the template being used for the payload
 * @param [data.type] - protobuf Type class to build the messages
 * @param {boolean} [returnAny] - return an array of messages of type ANY
 * @returns {OipDetails|Array.<ANY>}
 */


function buildOipDetails(data) {
  var returnAny = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(data)) {
    data = [data];
  }

  var anyDetails = [];

  var _iterator4 = _createForOfIteratorHelper(data),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var item = _step4.value;
      var name = item.name,
          payload = item.payload,
          descriptor = item.descriptor,
          type = item.type;

      if (!name || name === '') {
        throw Error("Must provide defined name. Received: ".concat(name));
      }

      if (!payload) {
        throw Error('Must provide payload object to create message from');
      }

      if (!type && !descriptor) {
        throw Error('Must provide either a protobufjs Type or a descriptor');
      }

      var TemplateType = void 0;

      if (descriptor) {
        TemplateType = (0, _decodeDescriptor.default)(descriptor).type;
      } else TemplateType = type; // serialize to correct type


      var fieldArray = TemplateType.fieldsArray;

      for (var field in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, field)) {
          var _iterator5 = _createForOfIteratorHelper(fieldArray),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var f = _step5.value;

              if (field === f.name) {
                // check for repeats
                if (f.repeated && !Array.isArray(payload[field])) {
                  payload[field] = [payload[field]];
                } // check for strings


                if (f.type === 'string') {
                  if (Array.isArray(payload[field])) {
                    var _iterator6 = _createForOfIteratorHelper(payload[field]),
                        _step6;

                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var _f = _step6.value;

                        if (typeof _f !== 'string') {
                          throw Error("Expected to be passed a string for field: { ".concat(field, " } - was given: ").concat(_f));
                        }
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                  } else {
                    if (typeof payload[field] !== 'string') {
                      throw Error("Expected to be passed a string for field: { ".concat(field, " } - was given: ").concat(payload[field]));
                    }
                  }
                } // check for Txids (OipRefs)


                if (f.type === 'Txid') {
                  try {
                    payload[field] = (0, _buildTxids.default)(payload[field]);
                  } catch (err) {
                    throw Error("Failed to convert field { ".concat(field, " } into txid messages: ").concat(err));
                  }
                } // check for bytes


                if (f.type === 'bytes') {
                  payload[field] = typeConvBytes(payload[field]);
                } // check for booleans


                if (f.type === 'bool') {
                  try {
                    payload[field] = typeConvBool(payload[field]);
                  } catch (err) {
                    throw Error("Failed to convert field { ".concat(field, " } into a bool: ").concat(err));
                  }
                } // check for all other number types


                if (protoNumberFields.includes(f.type)) {
                  try {
                    payload[field] = typeConvNumber(payload[field]);
                  } catch (err) {
                    throw Error("Failed to convert field: { ".concat(field, " } into a number: ").concat(err));
                  }
                }
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      }

      var _err = TemplateType.verify(payload);

      if (_err) throw Error("Failed payload verification for: ".concat(name, ": ").concat(_err));
      var message = TemplateType.create(payload);
      var buffer = TemplateType.encode(message).finish();
      var anyPayload = {
        type_url: serializeNameToTypeUrl(name),
        value: buffer
      };
      _err = ANY.verify(anyPayload);
      if (_err) throw Error("Failed payload verification attempting to build OipDetails for { ".concat(item.name, " }: \n ").concat(_err));
      var anyMessage = ANY.create(anyPayload);
      anyDetails.push(anyMessage);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (returnAny) {
    return anyDetails;
  }

  var OipDetailsPayload = {
    details: anyDetails
  };
  var err = OipDetails.verify(OipDetailsPayload);
  if (err) throw Error("Failed to verify OipDetails payload: \n ".concat(err));
  return OipDetails.create(OipDetailsPayload);
}